<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('closeModal')">
        <div class="modal-container" @click.stop>
          <div class="modal-header">
            <button type="button" class="btn py-3 flex-grow-1" :class="{ 'btn-active': isActiveTab == 'Title 1' }" @click="isActiveTab = 'Title 1'">
              <!-- <span aria-hidden="true">&times;</span> -->
              Check SJ & Unit
            </button>
            <button type="button" class="btn py-3 flex-grow-1" :class="{ 'btn-active': isActiveTab == 'Title 2' }" @click="isActiveTab = 'Title 2'">
              <!-- <span aria-hidden="true">&times;</span> -->
              Check Rute
            </button>
            <button type="button" class="close" @click="$emit('closeModal')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body" v-if="isActiveTab == 'Title 1'">
            <div class="wrapper">
              <div v-if="dataTable">
                <h1 class="title wrap-text text-center" style="font: normal normal normal 25px/38px Poppins">
                  {{ dataTable.no_referensi }}
                </h1>

                <div class="row text-left mt-5">
                  <div class="col-6">
                    <h3 style="font: normal normal normal 20px/30px Poppins">Total SJ</h3>
                    <h3 style="font: normal normal normal 20px/30px Poppins">Jumlah Unit</h3>
                    <h3 style="font: normal normal normal 20px/30px Poppins">Total SJ Supir</h3>
                    <h3 style="font: normal normal normal 20px/30px Poppins">Total Unit Supir</h3>
                  </div>
                  <div class="col-6">
                    <h3 style="font: normal normal normal 20px/30px Poppins">: {{ dataTable.total_sj }}</h3>
                    <h3 style="font: normal normal normal 20px/30px Poppins">: {{ dataTable.total_coly }}</h3>
                    <h3 style="font: normal normal normal 20px/30px Poppins">: {{ dataTable.driver_sj }}/{{ dataTable.total_sj }}</h3>
                    <h3 style="font: normal normal normal 20px/30px Poppins">: {{ dataTable.driver_coly }}/{{ dataTable.total_coly }}</h3>
                  </div>
                </div>
                <div class="row" style="margin-top: 50px">
                  <div class="col-md-6" style="display: flex; justify-content: center">
                    <button class="btn simple--button mt-3" type="button" @click="tolakPengecekan" style="font: normal normal normal 20px/30px Poppins" :disabled="dataTable.status !== 0">Tolak</button>
                  </div>
                  <div class="col-md-6" style="display: flex; justify-content: center">
                    <button class="btn simple--button mt-3" type="button" @click="setujuiPengecekan" style="font: normal normal normal 20px/30px Poppins; color: white; background-color: #1b698e" :disabled="dataTable.status !== 0">Setujui</button>
                  </div>
                </div>
              </div>
              <div class="text-center pt-5 pb-5" v-else>
                <h1>Loading...</h1>
              </div>
            </div>
          </div>

          <div v-else class="modal-body">
            <div class="wrapper">
              <div class="text-center" v-if="propData">
                <div class="row text-left mt-1">
                  <div class="col">
                    <div class="d-flex">
                      <h3 style="font: normal normal normal 20px/30px Poppins">NO TO</h3>
                      <h3 style="font: normal normal normal 20px/30px Poppins" class="ml-2">:</h3>
                      <h3 style="font: normal normal normal 20px/30px Poppins" class="wrap-text ml-2">{{ data.no_to }}</h3>
                    </div>
                    <div class="d-flex mt-2">
                      <h3 style="font: normal normal normal 20px/30px Poppins">NOPOL</h3>
                      <h3 style="font: normal normal normal 20px/30px Poppins" class="ml-2">:</h3>
                      <h3 style="font: normal normal normal 20px/30px Poppins" class="ml-2">{{ data.nopol }}</h3>
                    </div>
                    <div class="d-flex mt-2">
                      <h3 style="font: normal normal normal 20px/30px Poppins">Kode Rute</h3>
                      <h3 style="font: normal normal normal 20px/30px Poppins" class="ml-2">:</h3>
                      <h3 style="font: normal normal normal 20px/30px Poppins" class="ml-2">
                        {{ data.kode_rute }}
                      </h3>
                    </div>
                  </div>
                </div>

                <div class="divider mt-1"></div>

                <div class="mt-1" v-if="propData && propData.child.length > 0">
                  <div class="rute-card d-flex" v-for="dat in propData.child" v-bind:key="dat.no_to">
                    <div class="col-2 d-flex align-items-center justify-item-center">
                      <div class="rute-urutan-box">
                        <p v-if="dat.nomor != 0">
                          {{ zeroPad(dat.nomor, 2) }}
                        </p>
                        <p v-else>
                          <i class="fas fa-question" style="color: grey"></i>
                        </p>
                      </div>
                      <div class="text-center">
                        <p class="dealer--distance text-center">
                          +/-
                          <span class="ml-2">{{ dat.distance }}Km</span>
                        </p>
                      </div>
                    </div>
                    <div class="col-7 pl-2">
                      <p class="dealer-list-title dealer--name text-left">{{ dat.kd_dealer }}</p>
                      <p class="dealer--address text-left">{{ dat.address }}</p>
                    </div>
                    <div class="col-3">
                      <div class="mb-2">
                        <p class="dealer-list-title dealer--distance text-center">Kode Dealer</p>
                      </div>
                      <div>
                        <p class="dealer--distance text-center">
                          {{ dat.dealer_code }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="min-height: 400px; display: flex; align-items: center; justify-content: center" v-else-if="propData.child.length == 0">
                  <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey">No Data</p>
                </div>
                <div style="min-height: 400px; display: flex; align-items: center; justify-content: center" v-else>
                  <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey">Loading...</p>
                </div>

                <div class="row" style="margin-top: 50px">
                  <div class="col-md-6" style="display: flex; justify-content: center">
                    <button class="btn simple--button mt-3" type="button" @click="updatePengecekanRute(2)" style="font: normal normal normal 20px/30px Poppins" :disabled="propData.status !== 0">Tolak</button>
                  </div>
                  <div class="col-md-6" style="display: flex; justify-content: center">
                    <button class="btn simple--button mt-3" type="button" @click="updatePengecekanRute(1)" style="font: normal normal normal 20px/30px Poppins; color: white; background-color: #1b698e" :disabled="propData.status !== 0">Setujui</button>
                  </div>
                </div>
              </div>
              <!-- <div class="text-center pt-5 pb-5" v-else>
                                      <h1>Loading...</h1>
                                  </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
// import MultiSelect from 'vue-multiselect';

export default {
  data() {
    return {
      propData: null,
      dataTable: null,
      isActiveTab: "Title 1",
    };
  },
  props: ["data"],
  components: {
    // MultiSelect,
  },
  mounted() {
    this.loadApi();
    // this.loadApi2();
    this.fetchData();
  },
  watch: {},
  methods: {
    fetchData() {
      // this.$http.get(`/api/validation/rute-ekspedisi?no_to=TO/20211220/00000807&nopol=W9001P`)
      this.$http
        .get(`/api/validation/rute-ekspedisi?no_to=${this.data.no_to}&nopol=${this.data.nopol}`)
        .then((resp) => {
          this.propData = resp.data.data;
          console.log(this.propData);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    zeroPad(num, places) {
      return String(num).padStart(places, "0");
    },

    async loadApi() {
      try {
        let url = `/api/validation/to-detail?no_to=${this.data.no_to}&nopol=${this.data.nopol}`;
        // url = this.initialiseFilter(url , this.data)

        let resp = await this.$http.get(url);

        this.dataTable = resp.data.data[0];
      } catch (err) {
        console.log(err);
      }
    },
    // async loadApi2() {
    //     try {
    //         this.$http.get(`/api/validation/rute-ekspedisi?no_to=${this.data.no_to}&nopol=${this.data.nopol}`)
    //         .then((resp)=>{
    //             this.propData = resp.data.data[0]
    //         })
    //         // .catch((err)=>{console.log(err)});

    //     }
    //     catch(err) {
    //         console.log(err)
    //     }
    // },

    //FOR CHECK SJ & UNIT
    setujuiPengecekan() {
      this.$http
        .put("/api/validation/update-to", {
          no_to: this.data.no_to,
          status: 1,
          nopol: this.data.nopol,
        })
        .then(() => {
          this.$swal.fire({
            title: "Sukses!",
            text: "Pengecekan berhasil di setujui.",
            icon: "success",
          });
          this.$emit("refreshTable");
          this.$emit("closeModal");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    tolakPengecekan() {
      this.$http
        .put("/api/validation/update-to", {
          no_to: this.data.no_to,
          status: 2,
          nopol: this.data.nopol,
        })
        .then(() => {
          this.$swal.fire({
            title: "Sukses!",
            text: "Pengecekan berhasil di ditolak.",
            icon: "success",
          });
          this.$emit("refreshTable");
          this.$emit("closeModal");
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //FOR CHECK RUTE
    //0 = PENDING
    //1 = APPROVE
    //2 = REJECT
    updatePengecekanRute(status) {
      console.log("ini data rute", this.data);
      this.$http
        .put("/api/validation/update-rute", {
          insert_id: Number(this.data.rute_id),
          no_to: this.data.no_to,
          nopol: this.data.nopol,
          status: status,
        })
        .then(() => {
          this.$swal.fire({
            title: "Sukses!",
            text: `Pengecekan berhasil di ${status === 1 ? "setujui." : "ditolak."}`,
            icon: "success",
          });
          this.$emit("refreshTable");
          this.$emit("closeModal");
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 1020;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  width: 35%;
  background-color: #fff;
  border-radius: 8px;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33); */
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header {
  align-items: center;
  background-color: #f2f2f2;
  padding: 0;
}

.modal-header .btn {
  color: #8e8e8e;
  font-size: 18px;
}

.modal-header .btn.btn-active {
  background-color: #ffffff;
  color: #333333;
}

.modal-header .close {
  margin: 0;
  font-size: 2rem;
  font-weight: 400;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  padding: 0;
}

.modal-body .wrapper {
  padding: 32px;
}

.modal-default-button {
  float: right;
}

.wrap-text {
  word-wrap: break-word;
}

/*
      * The following styles are auto-applied to elements with
      * transition="modal" when their visibility is toggled
      * by Vue.js.
      *
      * You can easily play with the modal transition by editing
      * these styles.
      */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

/* MODAL STARTS */
.modal-body {
  margin: 0;
}

.modal-body .divider {
  height: 1px;
}

.modal-body .moduleLine {
  margin-bottom: 0vh;
}

.modal-body .moduleLine a {
  text-decoration: none;
}

.modal-body .moduleLine .moduleBox:hover {
  background-color: #e0e0e0;
  transition: background-color 0.7s ease;
  color: #212121;
  transition: color 0.7s ease;
}

.modal-body .moduleLine .moduleBox {
  border: 1px solid #bdbdbd;
  border-radius: 20px;
  padding: 20px 0;
  color: black;
  margin-bottom: 3vh;
}

.modal-body .moduleLine .moduleBox i {
  font-size: 5vh;
}

h3.modalHeadline {
  margin: 0 0 20px 0;
  font-weight: bold;
  text-align: center;
}

/* MODAL ENDS */

/* ==========================================================================
    #FORM made by Colorlib (https://colorlib.com)
    ========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding: 20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
       #TITLE made by Colorlib (https://colorlib.com)
       ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  /* margin-bottom: 40px; */
  text-align: center;
}

.sub--title {
  color: red;
  margin-bottom: 40px;
  text-align: center;
}

.modal-body {
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: auto;
}

.innerBox {
  padding: 0.8em 1.5em;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  background-color: white;
  box-shadow: 2px 2px 5px #e0e0e0;
}

.hoverable:hover {
  cursor: pointer;
}

.modal-stats {
  margin: 0 auto;
}

.modal-stats th {
  font: normal normal normal 13px/20px Poppins;
  padding-right: 20px;
}

.modal-stats td {
  font: normal normal normal 20px/28px Poppins;
}

.divider {
  width: 100%;
  height: 3px;
  background-color: grey;
}

.rute-card {
  background: #ffffff 0% 0% no-repeat padding-box;
  /* box-shadow: 0px 0px 6px #83838329; */
  /* border-radius: 8px; */
  padding: 20px 0;
}

.rute-card > div {
  display: flex;
  flex-direction: column;
  padding: 0;
}

.rute-card .rute-urutan-box {
  border: 5px solid #f77070;
  border-radius: 200px;

  height: 50px;
  width: 50px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.rute-card .rute-urutan-box p {
  font: normal normal normal 16px/18px Poppins;
  font-weight: bold;
  margin: 0;
}

.rute-card .dealer-list-title {
  font: normal normal 500 18px/20px Poppins;
  margin-bottom: 10px;
  color: #606060;
}

.rute-card .dealer--address {
  font: normal normal 500 14px/16px Poppins;
  margin: 0;
  color: #606060;
}

.rute-card .dealer-list-title .dealer--distance {
  font: normal normal 500 14px/16px Poppins;
  margin: 0;
  color: #606060;
}

.simple--button {
  width: 100%;
  box-shadow: 0px 0px 6px #00000029;
  border: 1px solid #000000;
  border-radius: 8px;
}
</style>
